{
	"audiences": {
		"admin": "Admin generale",
		"manager": "Gestore",
		"student": "Studente"
	},
	"blocks": {
		"body": "Testo",
		"button": "Pulsante",
		"greeting": "Saluto",
		"heading": "Titolo",
		"link_body": "Testo del link",
		"note": "Nota finale",
		"preview": "Anteprima nella casella",
		"subject": "Oggetto"
	},
	"columns": {
		"audience": "Destinatario",
		"code": "Codice",
		"email": "Email",
		"en": "Inglese",
		"it": "Italiano"
	},
	"content_title": "Contenuto dell'email",
	"default_text": "Testo predefinito",
	"emails": {
		"A1": "Anomalia di invio",
		"A2": "Decadenza non confermata",
		"A3": "Quota DSU sotto soglia",
		"E1": "Codice di accesso",
		"E11": "Conferma di accettazione del posto",
		"E12": "Conferma di rinuncia",
		"E13": "Decadenza confermata",
		"E15": "Esclusione o revoca",
		"E15C": "Esclusione annullata",
		"E16": "Proposta di camera",
		"E19": "Domanda valida",
		"E20": "Problema nella domanda",
		"E21": "Priorità per disabilità non confermata",
		"E22": "Richiesta del numero di matricola",
		"E3": "Ricevuta di invio della domanda",
		"E4": "Conferma di ritiro della domanda",
		"E5": "Domanda diretta registrata dal gestore",
		"E6": "Richiesta di chiarimento",
		"E7": "Esito della verifica della domanda",
		"E8": "Graduatoria pubblicata",
		"G1": "Invito all'account",
		"G10": "Nuova struttura affidata",
		"G3": "Domanda non consegnata alla PEC del bando",
		"G4": "Sollecito",
		"G5": "Nuova segnalazione sulla graduatoria",
		"G6": "Graduatoria di controllo pronta",
		"G7": "Offerta non consegnata",
		"G8": "Offerte da inviare dalla PEC della struttura",
		"G9": "Posto DSU non coperto"
	},
	"error": "Non riesco a caricare i testi. Ricarica la pagina.",
	"history": "Versioni",
	"history_default": "Versione 1, testo predefinito",
	"history_item": "Versione {{version}}, {{date}}, {{name}}",
	"issues": {
		"empty": "Scrivi il testo di questo blocco.",
		"malformed_variable": "C'è una graffa che non fa parte di una variabile: scrivi la variabile con una sola graffa per lato, come {nome}.",
		"missing_variable": "Manca {{variable}}: rimettila nel testo.",
		"repeated_variable": "{{variable}} si può usare una sola volta in questo blocco.",
		"unknown_block": "Questo blocco non esiste in questa email.",
		"unknown_variable": "{{variable}} non si può usare qui."
	},
	"legal": {
		"description": "L'offerta (E9) e le PEC (P1-P4) fanno parte delle regole del bando: non si modificano da qui e si leggono nel bando in PDF di ogni struttura.",
		"title": "Testi con valore legale"
	},
	"locales": {
		"en": "Inglese",
		"it": "Italiano"
	},
	"not_found": "Questa email non ha un testo modificabile.",
	"page_title": "Testi delle email",
	"preview_title": "Anteprima",
	"required": "Obbligatorie: {{variables}}.",
	"save": "Salva una nuova versione",
	"saved": "Nuova versione salvata: le prossime email useranno questo testo.",
	"subject": "Oggetto:",
	"variables": "Variabili:",
	"variables_global": "Puoi usare {piattaforma} in ogni testo: viene sostituito con il nome della piattaforma.",
	"version_on": "Versione {{version}} del {{date}}"
}
